import {
  PAYMENT_METHOD_TYPE_WALLET,
  PAYMENT_METHOD_TYPE_VJI_WALLET,
  PAYMENT_METHOD_NAME,
  BALANCE_STATE_ACTIVE,
  BALANCE_STATE_INACTIVE,
  BALANCE_STATE_ERROR,
} from 'shared_js/utils/buka20-constants';

export const buildMitraBalance = mitraBalance => ({
  name: PAYMENT_METHOD_NAME[PAYMENT_METHOD_TYPE_WALLET],
  altName: 'Saldo Mitra',
  type: PAYMENT_METHOD_TYPE_WALLET,
  state: BALANCE_STATE_ACTIVE,
  balance: mitraBalance?.dompet?.saldo ?? 0,
});

export const buildBukapayBalance = mitraBalance => {
  const walletVji = mitraBalance?.wallet_vji;
  const hasWalletVjiError = walletVji?.errors?.length > 0;

  return {
    name: PAYMENT_METHOD_NAME[PAYMENT_METHOD_TYPE_VJI_WALLET],
    altName: 'BukaPay',
    type: PAYMENT_METHOD_TYPE_VJI_WALLET,
    state: hasWalletVjiError
      ? BALANCE_STATE_ERROR
      : walletVji?.bind_status
        ? BALANCE_STATE_ACTIVE
        : BALANCE_STATE_INACTIVE,
    balance: hasWalletVjiError ? 0 : walletVji?.saldo ?? 0,
  };
};

export const buildAgentBalances = (mitraBalance, isWalletVjiEnabled) => {
  if (!mitraBalance) return [];

  return [
    buildMitraBalance(mitraBalance),
    ...(isWalletVjiEnabled ? [buildBukapayBalance(mitraBalance)] : []),
  ];
};
